import customerReducer from "@store/Store/Context/Customer/CustomerReducer";
import { combineReducers } from "redux";

const contextReducers = {
    customer: customerReducer,
};

export type ContextReducers = typeof contextReducers;

const contextReducer = combineReducers(contextReducers as any);
export default contextReducer;
